<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>広告媒体設定</span>
            </div>
            <div class="headerRightMenu">
                <Button @click="openCreateModal">新規追加</Button>
            </div>
        </div>

        <ul class="list">
            <template v-for="me in this.media">
                <li class="info" v-bind:key="me.id">
                    <div class="infoLeft">
                        <h3><span>【{{ me.id }}】</span>{{ me.name }}</h3>
                    </div>
                    <div class="infoRight">
                        <Button class="btn" @click="openUpdateModal(me.id)">編集</Button>
                    </div>
                </li>
            </template>
        </ul>

        <div class="listFooter">
        </div>
        <modal name="MediaSettingModal" :draggable="false" :resizable="false" width="80%" height="90%">
            <MediaSettingModal :mediaId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('MediaSettingModal')" />
        </modal>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import MediaSettingModal from '../components/MediaSettingModal.vue';

export default {
    components: {
        MediaSettingModal,
    },
    data() {
        return {
            statusMessage: "",
            media: {},
            selectedId: null,
            createMode: true,
        }
    },
    mounted: function () {
        this.getAccounts();
    },
    methods: {
        //登録済み広告媒体の一覧取得
        getAccounts: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/media/root/")
                .then((res) => {
                    this.media = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //追加
        openCreateModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('MediaSettingModal');
        },

        //更新
        openUpdateModal: function (id) {
            this.selectedId = id;
            this.createMode = false;
            this.$modal.show('MediaSettingModal');
        },

        //データを再取得してモーダルを閉じる
        modalClosed(modalName) {
            this.getAccounts();
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.$modal.hide(modalName)
        },

    },
}
</script>

<style scoped lang="sass">
.containerInner
    display: inline-grid
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
    .list
        background: $whiteColor
        font-size: 1.2rem
        margin: 10px 140px 0 140px
        overflow-y: scroll
        height: 750px
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            padding: 10px
            .btn
                width: 100px
                margin-left: 20px
                margin-bottom: 8px
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                h3
                    font-size: 1.5rem
                    font-weight: 700
                    margin-bottom: 10px
                p
                    margin: 0 0 10px 20px
                    font-size: 1.4rem
                    display: flex
                .inputText
                    margin-left: 10px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        display: flex
        justify-content: center
        .updateBtn
            width: 80px
    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 20px 0 0 10px
            .headerRightMenu
                margin-top: 10px
        .list
            margin: 10px 0 0
</style>